import { useMemo } from 'react';

import type { IValidatorProviderProps } from '../../../Validator/ValidatorProvider';
import type { IValidatorWrapperContext } from './types';
import { useDocumentsService } from '../../../DocumentsService/hooks/internal/useDocumentsService';
import { ValidatorProvider } from '../../../Validator/ValidatorProvider';

export const ValidatorWrapper = <TValue extends Record<string, unknown>>({
  children,
  value,
  ...rest
}: IValidatorProviderProps<TValue>) => {
  const { documents, files } = useDocumentsService();

  const valueWithFilesAndDocuments = useMemo(() => {
    const filesFromDocuments = documents.reduce((acc, document) => {
      const fileId = files.composeFileId({
        type: document.type,
        category: document.category,
        entityType: document.businessId ? 'business' : 'ubo',
        entityId: document.businessId ? document.businessId : document.endUserId!,
      });

      if (!document.files?.[0]) {
        return acc;
      }

      return {
        ...acc,
        [fileId]: new File([], document.files?.[0]?.name, {
          type: document.files?.[0]?.mimeType,
        }),
      };
    }, {});

    return {
      ...value,
      _documents: documents,
      _files: {
        ...filesFromDocuments,
        ...files.files,
      },
    } as TValue & IValidatorWrapperContext;
  }, [value, documents, files.files]);

  return (
    <ValidatorProvider value={valueWithFilesAndDocuments} {...rest}>
      {children}
    </ValidatorProvider>
  );
};
